import { useCallback, useState } from "react";

const CLAVE_STORAGE = "netjer-formacion-progreso-videos";

const leerProgreso = () => {
  try {
    const crudo = window.localStorage.getItem(CLAVE_STORAGE);
    return crudo ? JSON.parse(crudo) : {};
  } catch {
    return {};
  }
};

const guardarProgreso = (progreso) => {
  try {
    window.localStorage.setItem(CLAVE_STORAGE, JSON.stringify(progreso));
  } catch {
    // localStorage no disponible (modo privado, storage lleno, etc.): el progreso no persiste esta sesión.
  }
};

const useProgresoVideos = () => {
  const [progreso, setProgreso] = useState(leerProgreso);

  const marcarVisto = useCallback((url) => {
    if (!url) return;
    setProgreso((previo) => {
      if (previo[url]) return previo;
      const siguiente = { ...previo, [url]: true };
      guardarProgreso(siguiente);
      return siguiente;
    });
  }, []);

  const estaVisto = useCallback((url) => Boolean(progreso[url]), [progreso]);

  return { estaVisto, marcarVisto };
};

export default useProgresoVideos;
